import { Injectable } from '@angular/core';
import { BusinessLayerService } from '../../../services/business-layer.service';
import { ErrorCodes } from '@shared';
import { LoggingService } from '@shared/logging';
import {
	ExternalCreatedCheck,
	GapsCheck,
	IntervalRelatedCheck,
	OriginalHasQcCheck,
	StartAtZeroCheck
} from '../handlers';
import { IValidationsRule } from '../handlers/models';
import { DeleteChainParams } from '../handlers/models/delete-chain-params-type';
import { DeleteIntervalService } from './delete-interval.service';
import { SampleTypeProvider } from '../../../services/sample-type.provider';
import { TableTypeProvider } from '../../../services/table-type.provider';

@Injectable()
export class DeleteValidatorsOrchestratorService {
	public constructor(
		private loggerService: LoggingService,
		private deleteDataService: DeleteIntervalService,
		private businessLayerService: BusinessLayerService,
		private sampleTypeProvider: SampleTypeProvider,
		private tableTypeProvider: TableTypeProvider
	) {}

	public async startProcess(deleteChainParams: DeleteChainParams): Promise<IValidationsRule | null> {
		const externalCreatedHandler = new ExternalCreatedCheck(
			this.deleteDataService,
			this.loggerService,
			this.tableTypeProvider
		);
		const gapsHandler = new GapsCheck(this.deleteDataService, this.loggerService);
		const startAtZeroHandler = new StartAtZeroCheck(this.deleteDataService, this.loggerService);
		const originalHasQcHandler = new OriginalHasQcCheck(
			this.deleteDataService,
			this.loggerService,
			this.businessLayerService,
			this.sampleTypeProvider,
			this.tableTypeProvider
		);
		const intervalRelatedHandler = new IntervalRelatedCheck(
			this.deleteDataService,
			this.loggerService,
			this.businessLayerService
		);

		externalCreatedHandler.setNext(gapsHandler);
		gapsHandler.setNext(startAtZeroHandler);
		startAtZeroHandler.setNext(originalHasQcHandler);
		originalHasQcHandler.setNext(intervalRelatedHandler);

		try {
			return await externalCreatedHandler.handle(deleteChainParams);
		} catch (error) {
			this.loggerService.error(ErrorCodes.DeleteChainError, error);
			throw error;
		}
	}
}
